var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbstractModule, Factory } from '@g.frame/core';
import { ActionController } from '@g.frame/common.action_controller';
import { Loader } from "@g.frame/common.loaders";
import { UIManagerFactory } from "./UIManagerFactory";
export class UIModule extends AbstractModule {
    constructor() {
        super();
    }
    preInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.info('Module pre initialization.. Just make sure, that module is supported.');
            return {
                enabled: true
            };
        });
    }
    onInit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.uiManagerFactory = new UIManagerFactory();
            return [
                this.uiManagerFactory
            ];
        });
    }
    afterInit(agents) {
        this.uiManagerFactory.setModules(agents.get(Loader), agents.get(ActionController), agents.get(Factory));
    }
    onUpdate(params) {
        // console.info('Module on update function. Use it to update instances.');
    }
    onDestroy() {
        // console.info('Module destroy function. Use it to destroy and dispose instances.');
    }
    onResume() {
    }
    onPause() {
    }
}
